import { IRaisePropertyChanged } from "./IRaisePropertyChanged";
import { Event } from "event-system";
import { IBindable } from "./IBindable";

export class Bindable implements IRaisePropertyChanged, IBindable {
    public readonly propertyChanged: Event<Bindable, string>;

    public constructor() {
        this.propertyChanged = new Event();
    }

    protected onPropertyChanged(propertyName: string): void {
        this.propertyChanged.emit(this, propertyName);
    }

    public raisePropertyChanged(propertyName: string): void {
        this.onPropertyChanged(propertyName);
    }
}
